import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";

import { CasinoCard } from "@/components/casino-card";
import { Button } from "@/components/ui/button";
import type { Casino } from "@/lib/types";

/**
 * Dé casinolijst van de site. Deze component wordt overal gebruikt
 * (homepage, betaalmethodepagina's, casinozoeker) zodat de lijst er
 * overal exact hetzelfde uitziet.
 */
export function CasinoList({
  casinos,
  showRanks = true,
  methodSlug,
  methodName,
  emptyText = "Geen aanbieders gevonden met deze filters. Verruim je criteria.",
}: {
  casinos: Casino[];
  showRanks?: boolean;
  methodSlug?: string;
  methodName?: string;
  emptyText?: string;
}) {
  if (casinos.length === 0) {
    return (
      <p className="rounded-lg border border-dashed border-border p-8 text-center text-sm text-muted-foreground">
        {emptyText}
      </p>
    );
  }
  return (
    <div className="space-y-3 sm:space-y-4">
      {casinos.map((casino, i) =>
        showRanks ? (
          <CasinoCard
            key={casino.id}
            casino={casino}
            rank={i + 1}
            {...(methodSlug ? { methodSlug } : {})}
            {...(methodName ? { methodName } : {})}
          />
        ) : (
          <CasinoCard
            key={casino.id}
            casino={casino}
            {...(methodSlug ? { methodSlug } : {})}
            {...(methodName ? { methodName } : {})}
          />
        ),
      )}
    </div>
  );
}

/** Lijst + optionele afsluitende CTA naar de casinozoeker. */
export function CasinoListWithCta({ casinos, limit }: { casinos: Casino[]; limit?: number }) {
  const shown = limit ? casinos.slice(0, limit) : casinos;
  return (
    <>
      <CasinoList casinos={shown} />
      <div className="mt-6 text-center">
        <Button asChild variant="outline">
          <Link to="/casinozoeker/">
            Bekijk de volledige vergelijking
            <ArrowRight className="ml-1.5 h-4 w-4" aria-hidden />
          </Link>
        </Button>
      </div>
    </>
  );
}
